/** Gwiazdka pola wymaganego — używana wewnątrz `FormLabel`. */
export const RequiredMark = () => (
  <span className="text-crane-destructive" aria-hidden>
    {" *"}
  </span>
);

